<template>
<v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
            <h2>Plateforme de communication <br> Le Phare et La Source</h2>
              <v-img
                :src="require('../assets/logo.png')"
                class="my-3"
                contain
                height="200"
              />
              <h2>Bienvenue!</h2>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
import Vue from 'vue';
import { UserRoles } from '../modules/auth/auth.model';

export default Vue.extend({
  data () {
    return {
      errorMsg: '',
    }
  },
  methods: {
    redirection(){
      if (localStorage.getItem('user-role') === UserRoles.USER.key
      || localStorage.getItem('user-role') === UserRoles.SITEMNGR.key){
        this.$router.push('/evenements');
      }
    }
  },
  mounted: function() {
    this.redirection();
  }
})
</script>
